<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
    <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title>
        <h3>{{ get_dialogMain.title }}</h3>
      </v-toolbar-title>
      <v-spacer/>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <MainGeneralForm v-if="get_dialogMain.form !== 'importData'" :form="fields" :model="form" :on-success="save" :on-cancel="cancel" />
    <ImportDataForm v-else :itemAction="form" :on-success="saveImport" :on-cancel="cancel"/>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MainGeneralForm from '@/components/forms/main/MainGeneralForm'
import ImportDataForm from '@/components/forms/main/ImportDataForm'
export default {
  props: ['fields', 'model', 'urls', 'message'],
  data: () => ({
    form: {}
  }),
  components: {
    MainGeneralForm,
    ImportDataForm
  },
  mounted () {
    this.form = Object.assign({}, this.model)
  },
  methods: {
    ...mapActions(['postServiceAction', 'postServiceActionMultipart']),
    save (model) {
      if (this.get_dialogMain.body && this.get_dialogMain.body.content === 'form-data') {
        const formData = this.createFormData(model)
        this.postServiceActionMultipart({ url: this.urls, data: formData })
        return
      }
      this.postServiceAction({ url: this.urls, data: model })
    },
    createFormData (object) {
      const formData = new FormData()
      this.fields.map((field) => {
        formData.append(`${field.nameid}`, object[field.nameid])
      })
      return formData
    },
    saveImport (model) {
      console.log('model', model)
      // this.postServiceAction({ url: this.urls, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA', 'SET_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: this.message
      })
      if (this.get_dialogMain.body && this.get_dialogMain.body.content === 'form-data') {
        this.cancel()
        return
      } else if (this.get_dialogMain.body && this.get_dialogMain.body.exportpdf) {
        const linkSource = `data:application/pdf;base64,${val.pdf}`
        const downloadLink = document.createElement('a')
        downloadLink.href = linkSource
        downloadLink.download = val.nombre
        downloadLink.click()
        this.cancel()
        return
      }
      this.SET_DATA(val)
      // this.CLEAR_DATA()
      this.cancel()
    }
  }
}
</script>

<style></style>
